var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeBgStone3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 16,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.276 20.68a8.498 8.498 0 0 0-.4-.528c.034-.202.077-.408.12-.627-.133.094-.249.215-.348.352a3.341 3.341 0 0 1-.163-.185h-.005a9.405 9.405 0 0 0-.283-.305c.967-.804 2.093-1.646 3.28-2.097-.177.382-.34.773-.49 1.169-.723.653-1.363 1.43-1.711 2.222Zm-1.754-1.972c-.335-.31-.713-.455-1.182-.627.396-1.285.834-2.562 1.384-3.774.348-.765.74-1.5 1.2-2.2.532-.821 1.138-1.784 1.942-2.364.184.378-.782 1.332-.98 1.723a26.947 26.947 0 0 0-1.22 2.867c-.09.24-.177.486-.263.73-.42 1.187-.631 2.425-.88 3.645Zm-1.92-.924-.117-.051a28.496 28.496 0 0 0-2.131-.564l-.168-.85c-.408-1.986-.911-4.234-.971-6.296a11.14 11.14 0 0 1 .051-1.573c.185-1.715.662-3.391.894-5.076.043 1.925.49 3.945.64 5.9l.013.194c.13 1.921.593 3.932.761 5.905.06.675.082 1.35.047 2.011.048-.713.103-1.43.172-2.144.22-2.24.572-4.474 1.186-6.631a26.39 26.39 0 0 1 .55-1.71c.413-1.14.924-2.218 1.449-3.28.473-.958.962-1.904 1.414-2.875-.172.997-.512 1.951-.877 2.9-.056.151-.112.297-.172.448a39.37 39.37 0 0 0-1.414 4.323 32.24 32.24 0 0 0-.541 2.463 65.716 65.716 0 0 0-.585 3.846 30.461 30.461 0 0 0-.202 3.06Zm-2.257-.619c-.095-.021-.19-.038-.284-.06 0 0 .005 0 .005-.004-.58-.12-1.157-.21-1.724-.275-.64-1.17-1.354-2.102-2.501-3.065a5.962 5.962 0 0 0-1.143-.777 4.267 4.267 0 0 0-.65-.263c-.36-.107-.743-.086-1.04-.283.44-.035.839-.056 1.221-.056.486 0 .937.039 1.38.133.516.112 1.018.31 1.556.628.649.386 1.19.769 1.749 1.289.614.571.94 1.216 1.19 1.942.086.254.163.52.24.791Zm-6.404-.077c.391-.142.714-.232.851-.25.241-.03.477-.047.705-.047.043 0 .086 0 .125.005-.559.051-1.122.146-1.68.292Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.275 20.682c-.13-.185-.26-.361-.397-.529.03-.202.076-.408.122-.627a1.453 1.453 0 0 0-.352.352c-.053-.06-.114-.12-.16-.185h-.008c-.091-.103-.19-.206-.282-.305.97-.803 2.094-1.646 3.28-2.097-.177.382-.337.774-.49 1.17-.726.652-1.36 1.43-1.713 2.22Zm-1.75-1.973c-.337-.31-.719-.455-1.185-.627.397-1.285.833-2.561 1.384-3.774.351-.765.741-1.5 1.2-2.2.535-.821 1.139-1.784 1.942-2.364.183.379-.78 1.333-.979 1.723a27.247 27.247 0 0 0-1.223 2.867c-.084.241-.176.486-.26.731-.42 1.186-.635 2.423-.88 3.644Zm-1.92-.924c-.045-.017-.083-.034-.121-.051-.719-.22-1.43-.41-2.126-.564a27.141 27.141 0 0 1-.168-.85c-.413-1.986-.917-4.233-.97-6.297a10.675 10.675 0 0 1 .045-1.572c.184-1.715.665-3.391.895-5.076.046 1.925.489 3.945.642 5.9.007.066.007.13.015.194.13 1.921.589 3.933.757 5.905.061.675.084 1.35.046 2.011.053-.713.107-1.43.175-2.144.215-2.24.574-4.474 1.185-6.631.161-.577.352-1.148.55-1.711.414-1.138.926-2.217 1.446-3.279.474-.959.963-1.904 1.414-2.875-.168.997-.512 1.95-.871 2.901-.062.15-.115.297-.176.446a39.256 39.256 0 0 0-1.415 4.324c-.206.817-.39 1.633-.542 2.463a69.596 69.596 0 0 0-.581 3.846 29.395 29.395 0 0 0-.2 3.06Zm-2.262-.618c-.092-.023-.183-.04-.283-.06 0 0 .008 0 .008-.005-.581-.12-1.155-.21-1.728-.275a9.97 9.97 0 0 0-2.5-3.065 5.776 5.776 0 0 0-1.139-.777 4.357 4.357 0 0 0-.65-.262c-.359-.108-.741-.087-1.04-.284.437-.034.834-.056 1.216-.056.49 0 .94.038 1.384.133.512.112 1.017.31 1.552.628.65.387 1.192.769 1.75 1.289.62.572.94 1.216 1.193 1.942.084.254.16.52.237.792Zm-6.399-.078c.39-.142.711-.232.849-.25.245-.03.474-.047.703-.047.046 0 .084 0 .13.005-.566.052-1.123.146-1.682.292Z",
    fill: "url(#b)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 20,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.756 33.241c-.4 0-.8-.026-1.199-.09-2.63-.434-5.239-.993-7.869-1.358a8.754 8.754 0 0 0-1.169-.069c-.413 0-.834.017-1.255.039-.425.017-.846.038-1.268.038-.88 0-1.74-.085-2.544-.43-.958-.416-1.384-1.121-1.444-1.98a4.149 4.149 0 0 1 .116-1.212c-.137.588-.167 1.139-.056 1.624.005.004.005.009.005.013v.004a2.065 2.065 0 0 0 .593 1.04l.013.013.004.005.013.012c.004.005.008.005.008.009.005 0 .005.004.009.004.004.005.004.009.009.009a2.662 2.662 0 0 0 .688.438h.008c.004.005.008.005.013.009.008.004.017.004.025.008.795.348 1.66.434 2.536.434.421 0 .851-.021 1.276-.042.426-.018.851-.04 1.268-.04.391 0 .774.018 1.152.07 2.635.37 5.239.924 7.865 1.358.408.064.812.094 1.216.094a12.022 12.022 0 0 0-.013 0Zm.288-5.81c-.619 0-1.264-.176-1.569-.224-1.173-.18-2.063-1.564-3.15-1.74a.889.889 0 0 0-.15-.013c-.404 0-.757.28-1.109.554-.352.28-.71.559-1.117.559h-.026c-.903-.026-1.371-1.461-2.222-1.844a1.483 1.483 0 0 0-.576-.124c-.774 0-1.397.7-2.205 1.212-.416.266-.752.386-1.07.386-.42 0-.808-.214-1.306-.606-.31-.24-.602-.511-.886-.769.254-.408.529-.812.804-1.199a35.4 35.4 0 0 1 .68-.907c-.104.133-.207.267-.31.409.094.03.202.043.322.043.907 0 2.407-.838 2.755-.933.412-.116.877-.288 1.31-.288.203 0 .4.034.58.133.594.323.357.722.744 1.234.305.39.68.494 1.083.494.237 0 .482-.035.726-.069.245-.039.486-.073.718-.073.13 0 .25.009.37.039.675.15 1.47.739 2.222.739.219 0 .434-.052.644-.176 1.38-.83-.245-1.384-.86-1.728-.773-.421-1.851-.89-1.082-2.518.378-.8.902-.907 1.435-.907.1 0 .198.004.297.008.099.005.197.009.296.009.15 0 .297-.009.434-.043.658-.142 1.788-.838 2.227-1.99.094.022.189.039.283.06 0 0 .005.005.009.005.7.154 1.41.343 2.132.563l.116.051c.128.06.253.112.373.16-.159-.065-.322-.13-.494-.211-.46-.138-.907-.267-1.358-.374.125.073.254.142.378.215 1.088 3.12-1.147 3.098-2.35 3.807.137 1.823 2.879 3.73 2.273 5.312-.223.585-.782.744-1.371.744Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.762 33.241c-.396 0-.8-.026-1.196-.09-2.633-.435-5.244-.994-7.87-1.359a8.88 8.88 0 0 0-1.171-.068c-.411 0-.83.017-1.256.038-.426.018-.845.04-1.264.04-.883 0-1.743-.087-2.55-.43-.95-.418-1.377-1.123-1.438-1.982-.03-.378.015-.786.114-1.212-.137.589-.167 1.139-.053 1.624V29.82c.099.395.282.744.594 1.035v.005c.007.004.007.008.015.013v.004c.008.004.015.009.015.013.008.004.008.004.008.008.007 0 .007.005.007.005.008.004.008.009.008.009 0 .004.008.004.008.004.182.168.41.31.685.434h.007l.015.008c.008.005.016.005.023.01.792.347 1.66.433 2.535.433.426 0 .852-.021 1.278-.043.427-.017.853-.039 1.264-.039.396 0 .776.017 1.157.07 2.633.368 5.236.923 7.862 1.357.41.065.814.095 1.218.095a11.935 11.935 0 0 0-.015 0Zm.289-5.81c-.617 0-1.264-.177-1.568-.224-1.172-.181-2.063-1.565-3.151-1.74a.86.86 0 0 0-.152-.013c-.404 0-.754.279-1.104.554-.358.279-.715.558-1.119.558h-.03c-.898-.026-1.37-1.461-2.223-1.843a1.45 1.45 0 0 0-.57-.125c-.777 0-1.401.701-2.208 1.212-.418.266-.753.387-1.065.387-.427 0-.815-.215-1.31-.606-.311-.24-.6-.512-.882-.77.25-.408.525-.811.799-1.199.228-.313.457-.618.677-.906-.099.133-.205.266-.304.408.091.03.198.043.32.043.905 0 2.405-.838 2.755-.933.41-.116.875-.288 1.309-.288.205 0 .403.035.578.134.594.322.358.722.746 1.233.305.392.678.494 1.08.494.237 0 .488-.034.732-.068.243-.039.487-.073.715-.073.13 0 .251.008.373.039.67.15 1.469.739 2.222.739.213 0 .434-.052.64-.177 1.385-.829-.244-1.384-.86-1.728-.77-.42-1.85-.89-1.081-2.518.38-.8.906-.907 1.438-.907.1 0 .198.005.297.009.1.004.198.009.297.009.145 0 .297-.01.434-.044.654-.141 1.789-.838 2.222-1.99.1.022.19.04.282.061a28.914 28.914 0 0 1 2.146.567l.114.052c.13.06.252.112.373.159-.16-.065-.32-.13-.494-.21a24.045 24.045 0 0 0-1.355-.375c.122.073.251.142.373.215 1.088 3.12-1.142 3.099-2.352 3.808.145 1.822 2.884 3.73 2.276 5.312-.221.584-.784.743-1.37.743Z",
    fill: "url(#d)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 17,
    width: 7,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.145 22.723c.928-1.195 1.817-2.145 2.252-2.536 1.534-1.362 3.034-2.256 4.53-2.79-1.492.534-2.992 1.432-4.526 2.794-.439.391-1.324 1.337-2.256 2.532Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M2.914 16.991h7.315v6.025H2.914z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 16,
    width: 7,
    height: 2
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.925 17.4a9.72 9.72 0 0 1 1.01-.309c-.009 0-.017.004-.026.009a9.88 9.88 0 0 0-.984.3Zm5.41-.567c-.52-.06-1.035-.09-1.55-.09-.383 0-.766.017-1.148.056h-.022c.391-.039.782-.056 1.173-.056.512 0 1.027.03 1.548.086v.004Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M9.566 16.347h6.025v1.298H9.566z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 16,
    width: 8,
    height: 2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.062 17.102a17.203 17.203 0 0 0-1.72-.276v-.004c.568.065 1.144.155 1.724.275 0 .005-.004.005-.004.005Zm-6.146-.009c.009-.004.017-.009.026-.009.559-.146 1.121-.24 1.68-.292h.022a10.54 10.54 0 0 0-1.728.301Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M10.648 16.556h6.67v.868h-6.67z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 16,
    width: 16,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.663 24.448c-.752 0-1.547-.588-2.222-.739-.12-.03-.24-.039-.37-.039-.231 0-.472.035-.717.073-.245.035-.49.07-.726.07-.404 0-.778-.104-1.083-.495-.387-.512-.15-.911-.744-1.234a1.187 1.187 0 0 0-.58-.133c-.434 0-.898.172-1.31.288-.349.095-1.849.933-2.756.933-.12 0-.227-.013-.322-.043.103-.142.206-.275.31-.408.932-1.195 1.817-2.14 2.256-2.532 1.534-1.362 3.034-2.26 4.525-2.793.331-.12.658-.22.984-.301a10.54 10.54 0 0 1 1.728-.3 11.39 11.39 0 0 1 1.148-.057c.515 0 1.03.03 1.55.09.572.06 1.144.155 1.72.276-.438 1.151-1.569 1.848-2.226 1.99a1.798 1.798 0 0 1-.434.042c-.1 0-.198-.004-.297-.008a6.824 6.824 0 0 0-.296-.009c-.533 0-1.058.108-1.436.907-.769 1.629.31 2.097 1.083 2.518.615.344 2.24.899.86 1.728-.21.125-.426.176-.645.176Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M2.479 16.344h14.835v8.389H2.479z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 18,
    width: 2,
    height: 2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.193 19.383c-.211-.22-.426-.43-.645-.645-.009-.013-.021-.021-.03-.034l.03.03c.22.215.434.43.645.649Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M19.668 17.635h2.802v2.157h-2.802z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 18,
    width: 3,
    height: 2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.472 19.698c-.094-.107-.189-.21-.283-.31.094.1.193.203.283.306v.004Zm-.958-.988c-.335-.31-.718-.456-1.182-.628.468.172.847.318 1.182.628Z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M20.096 17.848h2.802v2.157h-2.802z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 24,
    width: 2,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.12 28.183c.245-1.058.83-2.235 1.53-3.361 0 .004 0 .004.004.004C.95 25.948.365 27.126.12 28.183Z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M-.105 24.516h2.157v4.091H-.105z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 17,
    width: 23,
    height: 14
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M.722 30.913c-.005 0-.005-.004-.009-.008a3.5 3.5 0 0 1 .009.008Zm-.018-.012c0-.005-.004-.005-.008-.01l.008.01Zm-.636-1.096c-.111-.486-.081-1.036.056-1.625.245-1.057.83-2.235 1.534-3.356.284.257.576.528.886.769.498.391.885.606 1.306.606.318 0 .654-.12 1.07-.387.808-.511 1.431-1.212 2.205-1.212.18 0 .37.039.576.125.85.382 1.32 1.818 2.222 1.843h.026c.408 0 .765-.279 1.117-.558.352-.275.705-.555 1.109-.555.051 0 .099.005.15.013 1.088.177 1.977 1.56 3.15 1.74.306.048.95.224 1.569.224.589 0 1.148-.159 1.371-.743.606-1.582-2.136-3.49-2.273-5.312 1.203-.71 3.438-.688 2.35-3.808-.124-.073-.253-.142-.378-.215.451.108.898.237 1.358.374.172.082.335.146.494.21l.366.138c.464.172.846.318 1.182.628.008.013.021.021.03.034.219.215.434.426.644.645.095.099.19.202.284.31-.74.863-1.384 1.864-1.586 3.18-.36 2.445 1.388 1.68 1.754 3.201.404 1.698-2.97 2.75-3.77 3.047-.743.275-1.444.4-2.135.4-1.015 0-2.003-.267-3.035-.705a1.937 1.937 0 0 0-.777-.159c-.447 0-.873.142-1.307.284-.438.142-.89.288-1.384.288-.666-.005-1.246-.177-1.689-.993-.176-.322-.28-1.212-.451-1.435-.176-.228-.382-.318-.615-.318-.928 0-2.204 1.474-2.952 1.848-.507.253-1.478.623-2.317.623-.545 0-1.03-.155-1.306-.598a2.493 2.493 0 0 1-.36-1.418c-.444 1.049-.658 2.05-.474 2.867Z",
    fill: "#fff"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M-.532 16.99h23.86v14.621H-.532z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 19,
    width: 2,
    height: 3
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.538 21.082c-.09-.137-.176-.27-.267-.4.09.13.18.263.267.4Zm-.666-.924c-.078-.095-.15-.19-.232-.275l.004-.004c.077.09.155.18.228.275v.004Z",
    fill: "#fff"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M22.247 19.568h1.513v1.943h-1.513z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 19,
    width: 2,
    height: 2
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.264 20.68a8.424 8.424 0 0 0-.4-.524v-.004c.138.168.27.344.4.529Zm-.632-.799c-.052-.064-.107-.124-.163-.189h.004c.052.065.108.125.163.185l-.004.004Z",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#w)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M22.244 19.356h1.298v1.728h-1.298z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 29,
    width: 1,
    height: 2
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M.66 30.855Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#y)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M-.314 29.453h18.918v4.091H-.314z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 19,
    width: 3,
    height: 3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.023 21.888a25.17 25.17 0 0 0-.752-1.204v-.004c.09.129.177.262.267.4.163.266.326.533.485.803v.005Zm-1.151-1.732c-.078-.095-.155-.185-.232-.275.081.086.154.18.232.275Z",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M22.247 19.574h2.157v2.587h-2.157z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 19,
    width: 2,
    height: 2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.264 20.68a10.605 10.605 0 0 0-.4-.528c.138.168.27.34.4.524v.005Zm-.632-.803c-.052-.064-.107-.125-.163-.185v-.004c.056.064.111.125.163.189Z",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M22.244 19.356h1.298v1.728h-1.298z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 25,
    height: 15
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.78 33.24c-.404 0-.808-.03-1.217-.094-2.625-.434-5.23-.989-7.864-1.358a8.498 8.498 0 0 0-1.152-.07c-.417 0-.842.022-1.268.04a25.48 25.48 0 0 1-1.276.043c-.877 0-1.74-.086-2.536-.434-.008-.005-.017-.005-.026-.01-.004-.003-.008-.003-.012-.008h-.01a2.664 2.664 0 0 1-.682-.434s-.005 0-.005-.004l-.008-.009c-.005 0-.005-.004-.009-.004l-.008-.009-.013-.012-.005-.005-.013-.013c-.004 0-.004-.004-.004-.004a2.047 2.047 0 0 1-.589-1.036v-.004c0-.004 0-.009-.004-.013-.185-.816.03-1.818.473-2.866-.017.494.09.98.36 1.418.276.443.761.597 1.307.597.838 0 1.81-.37 2.317-.623.748-.374 2.024-1.848 2.952-1.848.232 0 .439.09.615.318.172.224.275 1.113.451 1.436.443.816 1.023.988 1.689.992.494 0 .945-.146 1.384-.288.434-.141.86-.283 1.306-.283.25 0 .507.043.778.159 1.032.438 2.02.704 3.034.704.692 0 1.393-.124 2.136-.4.8-.296 4.173-1.349 3.77-3.046-.366-1.522-2.115-.757-1.754-3.202.202-1.315.847-2.316 1.586-3.18.056.06.111.12.163.184.077.09.155.181.232.276.138.167.267.343.4.528a24.98 24.98 0 0 1 .752 1.203c-.301 1.595-.438 3.348-.387 5.3.03 1.237.236 2.213.572 2.973-.185.06-.366.116-.55.172-.275.082-.546.168-.808.254-.7.224-1.345.447-1.917.683-.16.07-.314.133-.464.202-.052.026-.103.048-.155.073-.602.288-1.1.598-1.461.937-.005.005-.009.009-.009.013a2.22 2.22 0 0 0-.485.636c-.06.009-.12.013-.177.022-.472.056-.94.094-1.41.094Z",
    fill: "#fff"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#E)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M-.516 19.354h25.15v14.191H-.516z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "G",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 31,
    width: 3,
    height: 2
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.852 32.47c.361-.34.86-.65 1.462-.937-.1.047-.198.098-.297.146-.468.249-.864.507-1.165.79Z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#G)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M18.594 31.167h1.942v1.728h-1.942z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "I",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 31,
    width: 1,
    height: 1
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.314 31.54c.052-.026.104-.047.155-.073-.051.026-.103.052-.155.073Z",
    fill: "#fff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#I)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M19.888 31.17h.868v.653h-.868z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "K",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 31,
    width: 1,
    height: 1
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.318 31.924c-.129-.043-.228-.099-.275-.168l.052-.103a.81.81 0 0 0-.086.043v-.004c.099-.047.197-.1.296-.146.018.12.018.249.013.378Z",
    fill: "#fff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#K)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M19.661 31.177h1.083v1.083h-1.083z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "M",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 30,
    width: 3,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.93 31.259a24.82 24.82 0 0 1 .486-.19c-.167.065-.326.125-.485.19Z",
    fill: "#fff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#M)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M20.521 30.304h2.587v1.298h-2.587z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "O",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 31,
    width: 2,
    height: 1
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.469 31.48c.15-.07.305-.134.464-.203.159-.064.318-.124.486-.189-.34.13-.654.258-.95.392Z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#O)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M20.097 30.745h1.728v1.083h-1.728z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 31,
    width: 1,
    height: 1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.043 31.754c-.017-.017-.026-.038-.034-.06a.792.792 0 0 1 .085-.042l-.051.102Z",
    fill: "#fff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M19.661 31.384h.653v.653h-.653z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "S",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 25,
    width: 16,
    height: 10
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.486 34.781c.614-.855 1.34-1.199 2.286-1.538-.296-.19-.7-.19-1.048-.18-.967.016-1.586.279-2.446.781-.008-.322.297-.722.464-.988.22-.357.469-.692.718-1.027.408-.555.98-.83 1.44-1.311-.31-.056-.761.19-1.036.335-1.062.559-1.62 1.28-2.372 2.24-.056-1.681.507-3.585 1.057-5.162.34-.963.988-1.754 1.65-2.497-.855-.288-2.114 1.203-2.531 1.74-1.113 1.444-1.861 3.353-2.17 5.132-.254-.68-.177-1.41-.486-2.097-.284-.636-.757-1.105-1.2-1.634-.622-.739-1.43-1.319-2.204-1.882.314.79.89 1.496 1.246 2.282.512 1.148.813 2.433 1.16 3.632-.691-1.032-1.486-1.866-2.66-2.373-.696-.305-1.486-.447-2.243-.468-.266-.009-.872-.116-1.096.06.185.245.74.262 1.014.335.508.133.916.314 1.359.593.477.301.915.615 1.358.959.687.533 1.061 1.048 1.482 1.86-.657-.704-1.852-1.035-2.802-1.087-.88-.051-1.81.108-2.651.37-.314.099-.731.159-1.01.318.31.026.627-.082.94-.108.654-.051 1.32.035 1.97.125 1.447.202 2.71.593 3.888 1.47-.094-.391-.107-.55-.408-.757.254-.008.61.074.83.202.15.087.451.43.515.404-.176-.885-.012-1.383.275-2.2.138.155.086.559.117.782.073.495.27.916.27 1.419.533-1.088.971-1.827 1.96-2.502-.318.374-.58.821-.645 1.32-.038.305-.06 1.255.198 1.452.28-.266.74-.735 1.169-.86-.103.297-.305.718-.262 1.01.614-.455 1.28-.889 2.041-1.052-.154.202-.266.739-.137.902Z",
    fill: "#fff"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#S)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.485 34.782c.615-.855 1.345-1.2 2.287-1.538-.297-.19-.7-.19-1.049-.181-.965.017-1.588.28-2.446.782-.008-.322.296-.722.463-.988.22-.357.471-.692.722-1.028.403-.554.98-.829 1.436-1.31-.311-.056-.76.189-1.033.335-1.064.559-1.619 1.28-2.37 2.24-.061-1.681.5-3.585 1.055-5.163.335-.962.988-1.753 1.649-2.496-.859-.289-2.112 1.203-2.53 1.74-1.117 1.444-1.861 3.353-2.173 5.131-.25-.678-.175-1.41-.486-2.097-.281-.636-.752-1.104-1.2-1.633-.623-.739-1.429-1.32-2.204-1.882.312.79.89 1.495 1.246 2.282.517 1.147.813 2.432 1.163 3.631-.692-1.031-1.49-1.864-2.66-2.372-.698-.305-1.489-.447-2.24-.469-.274-.008-.874-.115-1.102.061.19.245.744.262 1.018.335.509.133.911.314 1.36.593.47.3.911.614 1.352.959.691.532 1.064 1.048 1.481 1.86-.653-.704-1.846-1.035-2.795-1.087-.882-.052-1.816.107-2.652.37-.319.099-.737.159-1.01.318.304.025.623-.082.942-.108.653-.051 1.314.035 1.967.125 1.444.202 2.713.593 3.89 1.47-.098-.391-.114-.55-.41-.757.25-.009.608.073.828.203.152.085.448.429.517.403-.175-.885-.015-1.384.273-2.2.137.155.084.559.114.782.076.494.274.916.274 1.418.532-1.087.972-1.827 1.96-2.501-.32.374-.577.821-.646 1.32-.038.304-.06 1.254.198 1.452.28-.266.737-.735 1.17-.86-.107.297-.304.718-.266 1.01.615-.455 1.284-.89 2.044-1.052-.152.202-.266.739-.137.902Z",
    fill: "url(#T)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "B",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#af",
    transform: "scale(.1 .08333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "f",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U",
    transform: "scale(.02941 .03571)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "l",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#X",
    transform: "scale(.0145 .02564)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "n",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y",
    transform: "scale(.07692 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "p",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Z",
    transform: "scale(.07692 .1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "r",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa",
    transform: "scale(.1 .05263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "t",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ab",
    transform: "scale(.009 .0147)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "v",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac",
    transform: "scale(.14286 .11111)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "x",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ad",
    transform: "scale(.16667 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "z",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ae",
    transform: "scale(.01136 .05263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "j",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W",
    transform: "scale(.03226 .25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "D",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag",
    transform: "scale(.16667 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "F",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ah",
    transform: "scale(.00855 .01515)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "H",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai",
    transform: "scale(.11111 .125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "J",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aj",
    transform: "scale(.25 .33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "L",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak",
    transform: "scale(.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "N",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#al",
    transform: "scale(.08333 .16667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "P",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#am",
    transform: "scale(.125 .2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "R",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#an",
    transform: "scale(.33333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#V",
    transform: "scale(.03571 .16667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "am",
    width: 8,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAABHNCSVQICAgIfAhkiAAAAEFJREFUCJltjTEOwDAIAy8SL62Usf/fch2AJkPYjO3zeOYrgIgKUpc6rM/NFAjMNsUBWPoH4zRtUiI3IZEd2XMiH90RNw/ZHL9bAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "an",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljbO+c/p8BCpgYkACc8///fwYAaYMFqYbiZ5QAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "al",
    width: 12,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAABHNCSVQICAgIfAhkiAAAAFBJREFUGJWVjkkKgEAMBEvJEwVv/v8X5SGZYRYvQiB0ujr0cd2PACI5H3vwowlNY4crUjo63PkhjDjcEc4/sEJMPRc4q1QxMxEb3IH22Sn4Ah8aZbg9CR8aAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "U",
    width: 34,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAABHNCSVQICAgIfAhkiAAAAXZJREFUSInNl8t2wyAMRKc5/GwX3fX7M1mQGD1GQBqnJ2xiB0lzJQG2v75/fokwePymqWw0s5u685gngHbdCLILlIRWcckBMqiey2q/WvaCye6B0h5U5wjNxnX4EK4tANCkoBJaitFfKUd6dcPTW7OX1UzImgW7GPjuHDUbC4qiY4VQMqp9qP3yGtkSCrNVK90/hK1+SLterPtC2ofhXu5O043mMJdiz7aFbkUSKkK3ab4gZ7aFEiSr9Du9fbd7YRpQncTm9HSewanV26MG8sWvE6Epis5olKqlukmX4vRlLHMW0JV42Iyd1GKJtFO2qY8Zm5iqF31cdquwfedL1MIVnR/BV9U6IPpoKdPEohulq0XLkv3E0+4AqZ++4W65kdiFJiAVRAdZhHeOnL0czCB0O+zYa80fs9yFQF+scuZciFWMfo68APES5IhBSJC9hXkmBABcPgECcBX5D4j7MSicL58AAYQXo3edESsIwH1g1UbvhgCAG1hWiDlHqoAIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "V",
    width: 28,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAGCAYAAADQQP5pAAAABHNCSVQICAgIfAhkiAAAAH9JREFUKJGFkjsOwCAMQ10p1+3UrYfndaCF/KQyxcR2PnCc143WSeELh7/3PDYk5SmaybNJdsrsWXQsy1x3Axx0JCSDvhjLuClI5FGIdSNfGcPvznWyQ59LRsRZwkx5WUz9O+Hfm0jSiAaj4TAibPo05ZWymmmkO0HzUbo49aAHhLxpA7M9WLoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "W",
    width: 31,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAECAYAAAB2v+RhAAAABHNCSVQICAgIfAhkiAAAAFhJREFUGJWtkEsOgDAIRJ+9onfzQB6M58KW+Iu1iSxImIFhYFrWWZUQVAzJOsSKRzQeNE58JG72xFGLZ60CgC1JP772eC8vcEmkq/mjuf0F9fLXuZGlY+Y2gKdpOApBEF8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "X",
    width: 69,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAnCAYAAABZsYV4AAAABHNCSVQICAgIfAhkiAAAAptJREFUaIHlmktuwzAMRKeA778ueoKe0tOFQ4mkfv7IipxmI0gxKfGZpAZBvr5/folJPiSzI0CQAEEgjEzWt3nu2cYoe3GbLaMDL30siC0ws4546G30cwQgkICNbWm0PgDOAeUuIBKmB8S4gQUyS6ZYEB6IOqx8XwOi4J4FQq7vhXIaSJhbIL48xJfpG+IzO1/flym+gbbHNQPoHBBfqiCwYgPy+mI8lORGKQCKwa0pKAiQEzcM6kA4GsoxILnSinZXrty4jwBRzZkDy2cWDZIDEkrwtc8QKCUg79AgG59Mj1K+b4cyWpTtuXJLQMT2VigzapAWkFt7yqwaxALx5bytd4dyXIPcBURsgNVducFGfBownaE8QYO0gAAdy6cLEKoMOArE3zABCEPvMc1a2YZ1dMyUmTVICYh/IRFQByhHgVy9cq2v6CPNtEzgO4AQF8tnmh+GqjeMjHLW0nqEexrKUzVIDYic/RSU3kB8NnhAPTVIrtw1kMM9ZR4NUgKibMSnA9ACAh7oKXuBxODm1CAtILsz5ZM0SATiSi3EtQPKEzVICQidL4DgSjtvlc81IK5/qCBeHipg3A2TZFpaumKbrB8EUs2UT9UguqflgBQzpQ6E6eFqQFwdQxgpQCM0SAmIL3MgA+VWUaZ8mb7hbO28rwZpATG3z/waRB1efDoAe4D48tfPyr7LOSDP1SAtICCx/DcNkmSeA5Jkyn/QID67PRCTKUeBUL8FFURMz9LoDuEzTQ6dAeKDugMIQSzxQR+UfdA76CvKxmkQY5sBAgKLBZKruQoQV8ey08waJNrInunLVD2lHxDTN5ytnY/XIC0gr0wp1J4AUTU4RINcALL3yrWAUlvVU2Ss/UHGgqiOLgjZ/N0apAwoZvsf2UA0wxJykiwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Y",
    width: 13,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAAFVJREFUKJGVjzkOACAIBNHwOxsb//+UtcGIsJpIxbETx9L6gEAEchZIt0qBvETIIsC6mQynrRlpkokpMpkeUXzA5E8XTZdTfuDg90v+Wn8Bp/cOx8QEP8sy4upaN88AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "Z",
    width: 13,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAKCAYAAABv7tTEAAAABHNCSVQICAgIfAhkiAAAAElJREFUKJGtkMsNwCAMxUyn6TaMw/Zxr4Aon6q5RErk5ygpl9sIUFEwuq6E7f7iQw0hF4N9UwX+d14XvA/NkqbQm21pGoHnjxAeVFwn1RpqQW8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "aa",
    width: 10,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAATCAYAAACp65zuAAAABHNCSVQICAgIfAhkiAAAAFBJREFUKJFjdHT1/s9ABGAiRhHRCv8ToxDmLrwKkR2PU+F/NB4LfgUIESZiFKEoxKeIgYEBYjW6e7ABJmIUoViNTxGSQsLRzUSMIjSrh75CAGfqE+hAInJvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ab",
    width: 111,
    height: 68,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ac",
    width: 7,
    height: 9,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAJCAYAAAD+WDajAAAABHNCSVQICAgIfAhkiAAAAB5JREFUGJVjdPMO+P+fATtgwiXBwMDAwIRHbohJAgDTEAPw5aMzSAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "ad",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAADVJREFUCJmNzbEJACAUA9HTVRzFady//2dhJRgw7eNIm2soYEkJKhZ0wg6YIBaP6i5M8POxAX/JD82bSTkIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ae",
    width: 88,
    height: 19,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAAATCAYAAAAUCsqbAAAABHNCSVQICAgIfAhkiAAAAhRJREFUWIXVl0FyBCEIRUmVt05VDpBLk8WIwgfUzDSdySaMliA++bT5+Pz6ZmKi/oeIiJj5Me6/+w/iYOws8VgzbTYPduTAxCOnuQb3M/PdF2PFFnMWP1a5Wiu+Y+zyR5/HfEvhynwQSJZb2GpN6ruHa8dXwk0KwhRGZm2hjL3l/AvftrzpC+DubzyYl7iS7AqMgS0B6+BiYcjaCDYx2QoO4bokELaX0Z1wMXfx2rYyPNcTLW4Hl9MKzuAubhxh7+WEsANbDLeixZEZc1TBJzf8GtwJ5ECaG6hxYcwLymBfClfFwsJoT8kpApHO3wR3oUKJFX9P8haXW9/i9EXpnNu1cA9lFMJWFU9yJ+x8q+Gi+jxU3+L0/q6CNdz737jTF/ezsPshjmBjzhmgYrh93CxccYhL/33fuAncpfqwMCzckzfuDi4TUauB63vUf3jjpnCDWA4uKroPWgwkkA3A3cvpdbhYpeL1Lm/cHVwmpvYbuE4i2Y072IG9Fe4zKlR2SluNtboEB+RNRC2TQCnckegaKib7J2/cBC7mPvACn/GRW4JI50FORjY1cO14xqp+465Ul8El6h+5M7iHNx3CBjlJguB7ZEvg4vl9LK2ctB2pPUaLsItw81q4AxH7WLHFg2WA8hZ3OVzNL8i5XdWjbn/jHsCtfuPu4BL3/+SehouVsEpiCVtKZwN1Ic1SuKjokcO+MH4AZvOFx1c6j/sAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "af",
    width: 10,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAABHNCSVQICAgIfAhkiAAAAElJREFUGJWN0TEKACAMQ9GveC8nF+9/nzoIolZLOmR6hNKm2rohTFaQDk2BNiOGtiKAGwIob+QP4RsfyMMPOmGAAMq9dNAofZAB4IIT119YxroAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "ag",
    width: 6,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAYAAADaxo44AAAABHNCSVQICAgIfAhkiAAAADlJREFUCJmNzMEJACAQA8H1KrERe7H/Ilxfwh2ImF8IkzZmV0FEQcUFwYmURGneBiuqIqmPq6dIaAMVzRS4JW1K+gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "ah",
    width: 117,
    height: 66,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "ai",
    width: 9,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAICAYAAAArzdW1AAAABHNCSVQICAgIfAhkiAAAAEpJREFUGJWFzUEKwCAMRNGv5GIFl97/Or+LGkFp6yph8siUq3VRAESWfcx6Aggxow8gUk8A2epegEjkIdEOeOr+gUJkOD+O+gQAN6F+W4xXGH2MAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "aj",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAACJJREFUCJljDA6P/c/wn4EBSjAwIXP+M/xnYELmMPxnYAAA1oMR/HlwqTcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "ak",
    width: 5,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAABHNCSVQICAgIfAhkiAAAACZJREFUCJljnDBpwX8GNMCELoBV8P///wwsyBwoi4EFmQNh/mcAAG1ZEMG0spfDAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 953.915,
    y1: -124.767,
    x2: 955.645,
    y2: -113.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#3E6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 966.221,
    y1: -154.379,
    x2: 999.122,
    y2: -154.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98C946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#3E6722"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E6722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 958.775,
    y1: -145.788,
    x2: 984.426,
    y2: -116.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F919F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#454A4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeBgStone3);
export default __webpack_public_path__ + "static/media/practice-bg-stone3.a2cd80c74e3b859659f2492e6da2b401.svg";
export { ForwardRef as ReactComponent };